import { render, staticRenderFns } from "./EmployeeCamera.vue?vue&type=template&id=1a5b1e82&scoped=true"
import script from "./EmployeeCamera.vue?vue&type=script&lang=js"
export * from "./EmployeeCamera.vue?vue&type=script&lang=js"
import style0 from "./EmployeeCamera.vue?vue&type=style&index=0&id=1a5b1e82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5b1e82",
  null
  
)

export default component.exports